'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import { ReduceStore } from 'flux/utils';
import GlobalHelper from '../../Common/Helpers/GlobalHelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_CONFIRMADOR_SOLICITUD,
    GET_SCREEN_DATA_RESULTADO_CONFIRMADOR_SOLICITUD,
    SET_USER_FUNCTIONS_CONFIRMADOR_SOLICITUD,
    CHANGE_ENTIDAD_CONFIRMADOR_SOLICITUD,
    //CAMBIAR_ESTADO_SOLICITUD,
    CERRAR_MODAL_CONFIRMADOR_SOLICITUD,
    INITIAL_STATE_CONFIRMADOR_SOLICITUD
} from '../../Screens/ConfirmadorSolicitud/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        razonSocial: "",
        empresa: undefined,
        cuentas: [],
        tarjetas: [],
        entidad: undefined,
        atlasCategoriaIva: [],
        rubros: [],
        loading: true,
        denegarOconfirmar: undefined,
        empresaSolicitud: false,
        cuentaSolicitud: false
    }
};

/**
 * Reduce store.
 */
let result;
function confirmadorSolicitud(state = initialState, action) {
    LogHelper.In(confirmadorSolicitud.name, state, action);

    switch (action.type) {
        case INITIAL_STATE_CONFIRMADOR_SOLICITUD:

            result = initialState;
            break;
        case GET_SCREEN_DATA_CONFIRMADOR_SOLICITUD:

            result = {
                ...state
            }
            break;

        case GET_SCREEN_DATA_RESULTADO_CONFIRMADOR_SOLICITUD:

            let entidadCorrespondiente = 0;
            if (action.resultado.empresaSolicitud) {
                entidadCorrespondiente = 1;
                if (action.resultado.cuentaSolicitud){
                    entidadCorrespondiente = 2;
                }
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    razonSocial: action.resultado.razonSocial,
                    empresa: action.resultado.empresa,
                    cuentas: action.resultado.cuentas,
                    tarjetas: action.resultado.tarjetas,
                    atlasCategoriaIva: action.resultado.atlasCategoriaIva,
                    entidad: entidadCorrespondiente,
                    rubros: action.resultado.rubros,
                    loading: false,
                    empresaSolicitud: action.resultado.empresaSolicitud,
                    cuentaSolicitud: action.resultado.cuentaSolicitud
                }
            }
            break;

        case CHANGE_ENTIDAD_CONFIRMADOR_SOLICITUD:
            result = {
                ...state,
                data: {
                    ...state.data,
                    entidad: action.entidadSeleccionada
                }
            }
            break;

       /* case CAMBIAR_ESTADO_SOLICITUD:
            result = {
                ...state,
                data: {
                    ...state.data,
                    estado: action.estado
                }
            }
            break;*/

        default:
            result = { ...state };
            break;
    }

    LogHelper.Out(confirmadorSolicitud.name, result);
    return result;
}
export default confirmadorSolicitud;